module.exports = __webpack_public_path__ + "037865b5c116397f4a8c9d969c8de727.svg";